import script from "./LP12.vue?vue&type=script&setup=true&lang=js"
export * from "./LP12.vue?vue&type=script&setup=true&lang=js"

import "./LP12.vue?vue&type=style&index=0&id=61ab1754&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ab1754"]])

export default __exports__